import { render, staticRenderFns } from "./Waste.vue?vue&type=template&id=2be4151b&scoped=true&"
import script from "./Waste.vue?vue&type=script&lang=js&"
export * from "./Waste.vue?vue&type=script&lang=js&"
import style0 from "./Waste.vue?vue&type=style&index=0&id=2be4151b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4151b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be4151b')) {
      api.createRecord('2be4151b', component.options)
    } else {
      api.reload('2be4151b', component.options)
    }
    module.hot.accept("./Waste.vue?vue&type=template&id=2be4151b&scoped=true&", function () {
      api.rerender('2be4151b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waste/Waste.vue"
export default component.exports